import { RightCircleFilled } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { Store } from 'antd/lib/form/interface';
import React, { useContext, useState } from 'react';

import AnchorComponent from 'components/atoms/AnchorComponent';
import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import InputPassword from 'components/atoms/InputPassword';
import Title from 'components/atoms/Title';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';

import zmenaEmailuApi from 'services/zmenaEmailu';

import routePathEnum from 'enums/routePathEnum';

import emailValidation from 'utils/validations/emailValidation';

interface IZmenaLogin {}

const ZmenaLogin: React.FC<IZmenaLogin> = () => {
    const [form] = useForm();
    const { language } = useContext(Context);
    const { navigateWorkaround } = useNavigateWorkaround();
    const [loading, setLoading] = useState<boolean>(false);
    const [status, setStatus] = useState<'OK' | 'DUPLICITA' | 'AUTENTIZACE'>();
    const onFinish = ({ password, loginNew }: Store) => {
        setLoading(val => !val);
        zmenaEmailuApi(password, loginNew, language)
            .then(resp => setStatus(resp.code))
            .catch(err => setStatus(err.response.status))
            .finally(() => {
                setLoading(val => !val);
            });
    };
    const okReturn = () => (
        <div>
            <Row>
                <TranslateText>LOGIN_ZMENA_MAIL</TranslateText>
            </Row>
            <Row>
                <Col span={24}>
                    <AnchorComponent link={true} to={routePathEnum.MAIN_PAGE}>
                        <ButtonComponent buttontext="POKRACOVAT" htmlType="button" id="pwNewRedirectBtn" />
                    </AnchorComponent>
                </Col>
            </Row>
        </div>
    );

    const defaultReturn = () => (
        <FormWrapper onFinish={onFinish} outForm={form}>
            <TranslateText>LOGIN_ZMENA_TEXT</TranslateText>
            <InputPassword
                label="HESLO"
                name="password"
                type="password"
                autoComplete="new-password"
                extramessage={status === 'AUTENTIZACE' ? 'HESLO_NESPRAVNE' : ''}
                onChange={() => setStatus(undefined)}
            />
            <InputComponent
                label="UZIVATELSKE_JMENO_NOVE"
                name="loginNew"
                autoComplete="new-password"
                rules={emailValidation()}
            />
            <Row className="button-row">
                <ButtonComponent
                    buttontext="ZPET"
                    htmlType="button"
                    onClick={() => navigateWorkaround(routePathEnum.MUJ_PROFIL)}
                    type="default"
                    id="pwNewZpetBtn"
                />
                <ButtonComponent
                    buttontext="POKRACOVAT"
                    onClick={() => form.submit()}
                    extramessage={status === 'DUPLICITA' ? 'LOGIN_ZMENA_MAIL_DUPL' : ''}
                    icon={<RightCircleFilled />}
                    loading={loading}
                    id="pwNewSubmitBtn"
                />
            </Row>
        </FormWrapper>
    );

    return (
        <>
            <Title text="ZMENIT_LOGIN" level={3} />
            {(!status || status === 'DUPLICITA' || status === 'AUTENTIZACE') && defaultReturn()}
            {status === 'OK' && okReturn()}
        </>
    );
};

export default ZmenaLogin;
